import { createRef } from "react";
import ApplyPMPExcludedService from "../../../service/applyPmpExcluded";
import ProcessBase from "../../commonComponents/processBase";
import { pmpExcludedReasonSelects } from "../../publicDictionaryValues";
import CompleteStepBusinessType from "../../../service/stepBase/completeStepBusinessType";
import StepService from "../../../service/stepBase/StepService";
import ApplyPMPExcludedStepService from "../../../service/applyPmpExcluded/applyPMPExcludedStepService";

const procedureRef = createRef();
export default class PMPExcludedProcess extends ProcessBase {
  constructor(props: any) {
    super(props);
    this.initProcedureFileState();
    // @ts-ignore
    this.taskExcludedProcedureStepID = null;
    // @ts-ignore
    this.initProcedureTableData = [];
  }

  /**
   * Init Component State
   */
  initProcedureFileState = () => {
    this.state = {
      pageState: {
        requestByID: null,
        requestByName: null,
        receiveDate: null,
        procedureID: null,
        procedureStepID: null,
        procedureFolder: {},
        currentRole: null,
        loading: false,
        procedureStepStatus: null,
        procedureStatus: null,
        procedureNote: "",
      },
      initTableDate: {},
      // @ts-ignore
      savedInSectionState: this.initSavedInSectionState,
      // @ts-ignore
      serverPathSectionState: this.initServerPathSectionState,
      // @ts-ignore
      procedureFileTableState: this.initProcedureFileTableState,
      fileTableData: [],
      supportingTableData: [],
      taskInfoData: {},
      procedureInfoData: {},
      procedureFileData: {},
      shareTaskData: {},
      ppoList: [],
      jbProcedureSavedIn: null,
    };
  };

  setSavedInServerPathState = (result: any) => {
    result.procedureFolder !== null &&
      this.setState({
        savedInSectionState: {
          ...this.state.savedInSectionState,
          savedInRadioValue: result.procedureFolder?.procedureSaveInCategoryID || null,
        },
        serverPathSectionState: {
          ...this.state.serverPathSectionState,
          serverPathValue: result.procedureFolder?.clientServerPath || null,
        },
      });
  };

  /* function about adjust data when get data from api */
  handleDataNull = (file: any, key: any) => {
    if (file[key] === null) {
      if (key === "procedureFileID") {
        return 0;
      } else {
        return null;
      }
    } else {
      return file[key];
    }
  };

  setProcedureFileData = (result: any) => {
    // @ts-ignore
    this.procedureFileStepID = this.taskExcludedProcedureStepID;
    this.setProcedureTableData(result.procedureFolder);

    this.setState({
      // @ts-ignore
      fileTableData: JSON.parse(JSON.stringify(this.procedureTableData)),
      jbProcedureSavedIn:
        result.procedureFolder === null ? null : result.procedureFolder.jbProcedureSaveIn,
    });

    this.setSavedInServerPathState(result);
  };

  setSupportingFileData = (result: any) => {
    this.setSupportingTableData(result);
    this.setState({
      // @ts-ignore
      supportingTableData: JSON.parse(JSON.stringify(this.supportingTableData)),
    });
  };

  setProcedureInfoData = (result: any) => {
    this.setState({
      procedureInfoData: {
        processId: result.processID,
        primaryProcedureOwnerId: result.primaryProcedureOwner?.primaryProcedureOwnerID,
        primaryProcedureOwnerName: result.primaryProcedureOwner?.primaryProcedureOwnerName,
        procedureOwnerId: result.procedureOwner?.procedureOwnerID,
        procedureOwnerName: result.procedureOwner?.procedureOwnerName,
        isPMPExcluded: result.applyPmpExcluded.isExcluded,
        pmpReasonSelect: result.applyPmpExcluded.excludedReasonID,
        pmpReasonInput: result.applyPmpExcluded.otherReason,
        note: result.procedureNote,
      },
    });
    // @ts-ignore
    this.taskExcludedProcedureStepID = result.applyPmpExcluded.taskExcludedProcedureStepID;
  };

  /**
   * Build SaveIn Section Data From ProcedureFolder
   * @param {*} data
   * @param {*} isRevise
   * @returns
   */
  buildSavedInSectionState = (data: any) => {
    return {
      savedInRadioValue: data.procedureSaveInCategoryID,
    };
  };

  /**
   * Build ServerPath Section Data From ProcedureFolder
   * @param {*} data
   * @param {*} isRevise
   * @returns
   */
  buildServerPathSectionState = (data: any) => {
    return {
      // @ts-ignore
      ...this.primitiveServerPathSectionState,
      serverPathValue: data.clientServerPath,
    };
  };

  _getFlowDataSuccess = (result: any) => {
    const { procedureStepStatus } = result;
    let mergePayloadMap = undefined;

    StepService.setStepInterfaceMergePayload(result, {
      isShareTaskProcess: false,
      isHistorical: procedureStepStatus === "Complete",
      // @ts-ignore
      procedureStepId: this.procedureStepID,
      // @ts-ignore
      procedureTaskId: this.taskID,
    });

    if (procedureStepStatus === "Complete") {
      ApplyPMPExcludedStepService.getProcedureOwnerStepKey = () =>
        CompleteStepBusinessType.procedureOwner;
      ApplyPMPExcludedStepService.getPrimaryProcedureOwnerStepKey = () =>
        CompleteStepBusinessType.primaryProcedureOwner;
      mergePayloadMap = StepService.getMergePayloadBySettingKey([
        CompleteStepBusinessType.procedureOwner.settingKey,
        CompleteStepBusinessType.primaryProcedureOwner.settingKey,
      ]);
    }

    this.getInitData(
      ApplyPMPExcludedService.getApplyPmpExcludedStepItem,
      "Get Procedure Information Failed",
      undefined,
      result,
      {
        ...mergePayloadMap,
        ...StepService.getMergePayloadBySettingKey([CompleteStepBusinessType.taskInfo.settingKey]),
      }
    );
  };

  _getFlowDataFailed = () => {
    this._alertError("Get PMP Excluded Flow Data Failed");
  };

  getFlowData = () => {
    const parentPageData = this._getRoutingParam("ParentPage");
    const param = {
      // @ts-ignore
      taskID: this.taskID,
      // @ts-ignore
      procedureID: this.procedureID,
      // @ts-ignore
      procedureStepID: this.procedureStepID,
      parentPage: parentPageData,
    };

    ApplyPMPExcludedService.getFlowStepData(
      param,
      this._getFlowDataSuccess,
      this._getFlowDataFailed
    );
  };

  componentDidMount() {
    this.getFlowData();
  }

  /* function about get data from procedure file table */
  returnFileDataValue = (name: any, index: any) => {
    // @ts-ignore
    const procedureFileData = procedureRef.current.getDataList();
    // @ts-ignore
    let deleteList = procedureRef.current.getDeleteList();
    let combineDatalist = procedureFileData.concat(deleteList);
    return combineDatalist[index].data.find((item: any) => item.name === name);
  };

  /* function about return submit data to use in integrate trigger api */
  handleReturnSubmitData = (actionID: any, actionName: any, infoCurrent: any, pageCurrent: any) => {
    let isPMPExcluded = null;
    let pmpReasonSelect = null;
    let pmpReasonInput = null;
    let rejectReason = null;
    if (infoCurrent !== null && actionName === "Approve") {
      isPMPExcluded = infoCurrent.state.currentPMPExcluded;
      pmpReasonSelect = infoCurrent.state.currentPMPExcludedReasonSelect;
      pmpReasonInput = infoCurrent.state.currentPMPExcludedReasonInput;
    } else if (infoCurrent !== null && actionName === "Reject") {
      isPMPExcluded = this.state.procedureInfoData.isPMPExcluded;
      pmpReasonSelect = this.state.procedureInfoData.pmpReasonSelect;
      pmpReasonInput = this.state.procedureInfoData.pmpReasonInput;
    }
    if (pageCurrent !== null) {
      rejectReason = pageCurrent.state.pageState.rejectReason;
    }

    return {
      procedureProcessId: null,
      // @ts-ignore
      workflowProcessInstanceId: this.workflowProcessInstanceId,
      // @ts-ignore
      flowCategoryID: this.flowCategoryID,
      actionName: actionName,
      actionID: actionID,
      accountID: null,
      // @ts-ignore
      procedureStepID: this.procedureStepID,
      rejectReason: rejectReason,
      action: 0,
      // @ts-ignore
      taskExcludedProcedureStepID: this.taskExcludedProcedureStepID,
      isExcluded: isPMPExcluded,
      excludedReasonId: pmpReasonSelect,
      reason: pmpReasonSelect === pmpExcludedReasonSelects.otherReason ? pmpReasonInput : null,
    };
  };
}
